import { i18nDefaultOptions, i18nLangDetectionConfig, } from "@sundae/i18n-config";
import i18next from "i18next";
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next } from "react-i18next";
export const languages = [
    {
        locale: "ar",
        localeString: "عربي",
    },
    {
        locale: "de",
        localeString: "Deutsch",
    },
    {
        locale: "en",
        localeString: "English",
    },
    {
        locale: "es",
        localeString: "Español",
    },
    {
        locale: "fr",
        localeString: "Français",
    },
    {
        locale: "it",
        localeString: "Italiano",
    },
    {
        locale: "ja",
        localeString: "日本語",
    },
    {
        locale: "nl",
        localeString: "Nederlands",
    },
    {
        locale: "pt",
        localeString: "Português",
    },
    {
        locale: "ru",
        localeString: "Русский",
    },
    {
        locale: "th",
        localeString: "ภาษาไทย",
    },
];
const namespaces = [
    "common",
    "wallet",
    "header",
    "not-found",
    "glossary",
    "warnings",
    "error-fallback",
];
export const initI18N = async ({ clientNamespace, clientTranslations, }) => {
    i18next.on("failedLoading", (lng, ns, msg) => console.error(msg));
    i18next
        .use(initReactI18next)
        .use(resourcesToBackend((language, resourceNamespace) => {
        if (resourceNamespace === clientNamespace) {
            return clientTranslations[language];
        }
        return import(`./translations/${language}/${resourceNamespace}.json`);
    }))
        .init({
        fallbackLng: "en",
        ...i18nDefaultOptions(languages),
        detection: i18nLangDetectionConfig,
        ns: [...namespaces, clientNamespace].filter(Boolean),
        defaultNS: "common",
    });
    return i18next;
};
//# sourceMappingURL=index.js.map